const videoEffect = document.getElementById("how-to-use-effect");
const fullscreenButtonEffect = document.querySelector(".full-screen-effect");

fullscreenButtonEffect.addEventListener("click", function () {
  if (videoEffect.webkitSupportsFullscreen) {
    videoEffect.webkitEnterFullscreen();
    return;
  }

  videoEffect.requestFullscreen();
});

document.addEventListener("fullscreenchangeEffect", function () {
  if (document.fullscreenElementEffect) {
    videoEffect.setAttribute("controls", true);
    return;
  }

  videoEffect.removeAttribute("controls");
});